import React from 'react';
import { Center, CenterProps } from '@chakra-ui/react';
import { WaveIcon } from '../../icons';

export const RemarkDivider: React.FC<CenterProps> = (props) => {
  return (
    <Center py="10px" w="100%" {...props}>
      <WaveIcon color="scheme.contentInverseSecondary" h="5px" />
    </Center>
  );
};
